// app-lock.js — verrouillage UI local v4.7.0.
// Ce verrou empêche l'affichage de l'app sans le code local. Il NE chiffre pas
// IndexedDB : un accès forensique au stockage navigateur reste hors de portée.
const KEY = 'messagerie:app-lock:v1';
const HIDDEN_AT = 'messagerie:app-lock-hidden-at:v1';
const ITERATIONS = 180000;

function b64(bytes) {
  let s = ''; for (const b of bytes) s += String.fromCharCode(b);
  return btoa(s);
}
function unb64(s) {
  const raw = atob(s); return Uint8Array.from(raw, (c) => c.charCodeAt(0));
}
async function derive(code, salt) {
  const material = await crypto.subtle.importKey('raw', new TextEncoder().encode(String(code)), 'PBKDF2', false, ['deriveBits']);
  const bits = await crypto.subtle.deriveBits({ name: 'PBKDF2', hash: 'SHA-256', salt, iterations: ITERATIONS }, material, 256);
  return new Uint8Array(bits);
}
function constantTimeEqual(a, b) {
  if (a.length !== b.length) return false;
  let diff = 0; for (let i = 0; i < a.length; i++) diff |= a[i] ^ b[i];
  return diff === 0;
}
export function isAppLockConfigured() {
  try { const v = JSON.parse(localStorage.getItem(KEY) || 'null'); return !!(v?.salt && v?.hash); } catch (_) { return false; }
}
export async function setAppLockCode(code) {
  const value = String(code || '');
  if (value.length < 4 || value.length > 64) throw new Error('Le code local doit contenir entre 4 et 64 caractères.');
  const salt = crypto.getRandomValues(new Uint8Array(16));
  const hash = await derive(value, salt);
  localStorage.setItem(KEY, JSON.stringify({ v: 1, salt: b64(salt), hash: b64(hash), iterations: ITERATIONS }));
}
export async function verifyAppLockCode(code) {
  let v; try { v = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (_) { return false; }
  if (!v?.salt || !v?.hash) return true;
  try {
    const actual = await derive(String(code || ''), unb64(v.salt));
    return constantTimeEqual(actual, unb64(v.hash));
  } catch (_) { return false; }
}
export function disableAppLock() { localStorage.removeItem(KEY); localStorage.removeItem(HIDDEN_AT); }
export function rememberHiddenAt(at = Date.now()) { localStorage.setItem(HIDDEN_AT, String(at)); }
export function hiddenDuration(now = Date.now()) { return Math.max(0, now - Number(localStorage.getItem(HIDDEN_AT) || now)); }
export function clearHiddenAt() { localStorage.removeItem(HIDDEN_AT); }
